/**
 * 業態別企画書データ出力画面　業態別企画書データ出力検索条件VOクラス
 */
export class KYMW1311CatalogDataCsvModel {

  public orderCodeFrom: string = null;                                          // 受注コード(From)
  public orderCodeTo: string = null;                                            // 受注コード(To)
  public pCode: string = null;                                                  // Ｐコード
  public mediumType: string = null;                                             // 媒体区分
  public classificationsList: Array<any> = new Array<any>();                    // 部門コードリスト
  public dutiesWeeklyFlag: string = null;                                       // 業態区分（ウィークリー）(0：掲載なし、1：掲載あり)
  public dutiesFormDailyDivList: Array<any> = new Array<any>();                 // 業態区分（デイリー）リスト
  public dutiesSpotFlag: string = null;                                         // 業態区分（スポット）(0：掲載なし、1：掲載あり)

}
